import { render, staticRenderFns } from "./FastGoForm.vue?vue&type=template&id=af81c3fa&scoped=true"
import script from "./FastGoForm.vue?vue&type=script&lang=js"
export * from "./FastGoForm.vue?vue&type=script&lang=js"
import style0 from "./FastGoForm.vue?vue&type=style&index=0&id=af81c3fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af81c3fa",
  null
  
)

export default component.exports